import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';
import { RoleService } from 'src/app/Modules/user-management/permissions/services/role.service';

/**
 * Järjestelmävalvoja-only routes: asks the API who the caller is (the same RolePermission/caller the role pages use)
 * and sends everyone else, and any failure, to /unauthorized. Always pair with AuthGuard. The API still enforces the role on every write.
 */
export const systemAdminGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const denied = router.createUrlTree(['/unauthorized']);
  return inject(RoleService)
    .getCaller()
    .pipe(
      map((caller) => (caller?.isSystemAdmin ? true : denied)),
      catchError(() => of(denied)),
    );
};
